// Inline SVG icon component — replaces @reacticons/ionicons
// Only ships the 3 icons actually used in the app (checkmark, link-outline, close)
// Icon paths copied verbatim from Ionicons source (MIT license).
//
// Usage:
//   <Icon name="close" />
//   <Icon name="checkmark" style={{ color: '#4ade80' }} />
//   <Icon name="link-outline" style={{ fontSize: '1.4em' }} />
//
// The component mimics IonIcon's API (name + style + className) so the
// surrounding JSX didn't need to change.

import React from 'react';

const ICONS = {
  // ionicons/src/svg/checkmark.svg
  checkmark: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M416 128L192 384l-96-96"
    />
  ),
  // ionicons/src/svg/close.svg
  close: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      d="M368 368L144 144M368 144L144 368"
    />
  ),
  // ionicons/src/svg/link-outline.svg
  'link-outline': (
    <>
      <path
        d="M208 352h-64a96 96 0 010-192h64M304 160h64a96 96 0 010 192h-64M163.29 256h187.42"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
    </>
  ),
};

export default function Icon({ name, style, className, ariaLabel }) {
  const svgContent = ICONS[name];

  if (!svgContent) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`<Icon name="${name}" /> — unknown icon name`);
    }
    return null;
  }

  // Size via font-size on the SVG (matches IonIcon behaviour)
  const sizeStyle = {
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    ...style,
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
      style={sizeStyle}
      aria-label={ariaLabel || name}
      role="img"
    >
      {svgContent}
    </svg>
  );
}
